import { SolidifyableData } from "../../../../../core/data/SolidifyableData";
import { Balance } from "../../../../model/data/Balance";
import { BalanceManager } from "../../../../model/data/BalanceManager";
import { Constants, CurrencyType } from "../../constant/Constants";
/**
 * BalanceResponseData.ts
 */
export class BalanceResponseData extends SolidifyableData {
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.solidifyBalances();
            this.solidifyActiveBalance();
            this.solidifyWinProcessorRsp();
            BalanceManager.getInstance().setBalance(this);
        }
    }
    solidifyBalances() {
        this.balances = [];
        this.bonusBalances = [];
        let balancesData = this.data.getDataArray(Constants.PROPERTY_ACCOUNT_BALANCE);
        if (!balancesData || !balancesData.length) {
            balancesData = this.data.getDataArray(Constants.PROPERTY_BALANCE);
        }
        console.log("Balances Data: ", balancesData);
        if (balancesData && balancesData.length) {
            for (let i = 0; i < balancesData.length; i++) {
                let balanceData = balancesData[i];
                let type = balanceData.getString(Constants.PROPERTY_TYPE);
                if (!type) {
                    type = balanceData.getString(Constants.PROPERTY_TYPE_SHORT);
                }
                if (type == CurrencyType.CASH) {
                    this.balances.push(Balance.create(balanceData));
                }
                else if (type == CurrencyType.BONUS) {
                    this.bonusBalances.push(Balance.create(balanceData));
                }
            }
            this.currencyCode = this.balances[0].getCurrency();
        }
    }
    solidifyActiveBalance() {
        this.activeBalanceType = this.data.getString(Constants.PROPERTY_ACTIVE_BALANCE);
        if (this.activeBalanceType) {
            this.postWager = this.data.getBool(Constants.PROPERTY_POST_WAGER);
        }
    }
    solidifyWinProcessorRsp() {
        let rsp = this.data.getNumber(Constants.PROPERTY_WIN_PROCESSOR_RSP);
        this.winProcessorRsp = rsp ? rsp : 0;
    }
    getBalances() {
        return this.balances;
    }
    getBonusBalances() {
        return this.bonusBalances;
    }
    getActiveBalanceType() {
        return this.activeBalanceType;
    }
    getWinProcessorRsp() {
        return this.winProcessorRsp;
    }
    isPostWager() {
        return this.postWager;
    }
    getCurrencyCode() {
        return this.currencyCode;
    }
}
//# sourceMappingURL=BalanceResponseData.js.map